// components
import { IconComponent } from '@centria-ui-atoms/icon-component'
import { Typography } from '@centria-ui-atoms/typography'

// bootstrap components
import { Container } from 'react-bootstrap'

// prime components
import { Dialog } from 'primereact/dialog'

// hooks
import { useWindowSize } from '@centria-ui/hooks/use-window-size'

// commons
import { windowsBreakPoints } from '@centria-ui/commons/enums'

// styles
import classes from './styles.module.scss'

// types
import type { DialogProps as PrDialogProps } from 'primereact/dialog'
import type { variantsEnum } from '@centria-ui/commons/enums'
import type { sizeEnums } from '@centria-ui/commons/enums'
import type { FC, ReactNode } from 'react'

export interface DialogProps extends PrDialogProps {
  title?: string
  loading?: boolean
  showClose?: boolean
  description?: ReactNode
  size?: keyof typeof sizeEnums
  color?: keyof typeof variantsEnum
}

export const Modal: FC<DialogProps> = ({
  title,
  onHide,
  visible,
  children,
  description,
  size = 'lg',
  className = '',
  loading = false,
  color = 'white',
  showClose = true,
  ...props
}) => {
  const { screenWidth } = useWindowSize()
  const sizeModal = screenWidth < windowsBreakPoints.md ? 'xl' : size
  const position = screenWidth < windowsBreakPoints.md ? 'bottom' : 'center'

  return (
    <Dialog
      blockScroll
      onHide={onHide}
      closable={false}
      draggable={false}
      resizable={false}
      visible={visible}
      position={position}
      headerClassName={classes.modal_header}
      contentClassName={classes.modal_content}
      className={`${classes[`modal_${color}`]}  ${
        classes[`modal_size_${sizeModal}`]
      }  ${className}`}
      {...props}>
      <Container>
        {(title || showClose || description) && (
          <>
            <div className={classes.header}>
              {title && (
                <Typography
                  fontSize='title'
                  fontcolor='primary'
                  fontWeight='semiBold'
                  className='w-100 text-center'>
                  {title}
                </Typography>
              )}
              {showClose && (
                <IconComponent
                  size='sm'
                  color='primary'
                  icon='CrossIcon'
                  onClick={onHide}
                  className='ms-auto'
                />
              )}
            </div>
            {typeof description === 'string' ? (
              <Typography fontSize='button' className='text-center mb-3'>
                {description}
              </Typography>
            ) : (
              description
            )}
          </>
        )}
      </Container>
      <Container className={classes.modal_container}>
        {!loading && children}
      </Container>
    </Dialog>
  )
}
